import { render, staticRenderFns } from "./PersonaComponent.vue?vue&type=template&id=f0eff1a2&scoped=true&"
import script from "./PersonaComponent.vue?vue&type=script&lang=js&"
export * from "./PersonaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0eff1a2",
  null
  
)

export default component.exports